<template>
  <div class="navbar">
    <div class="logo" @click="(collapsed = true), (fadeout = true)">
      <slot name="logo"></slot>
    </div>

    <div
      class="hamburger"
      @click="(collapsed = !collapsed), (fadeout = false)"
      :state="collapsed"
    >
      <hamburger-icon :state="collapsed" />
    </div>

    <transition :name="fadeout ? 'fade' : 'slide'">
      <div
        class="dropdown-menu"
        :class="{ collapse: collapsed }"
        v-show="!collapsed"
      >
        <div class="dropdown-content" @click="fade">
          <slot></slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import hamburgerIcon from "@/components/HamburgerIcon";
import { gsap } from "gsap";

export default {
  name: "navBar",
  components: {
    hamburgerIcon
  },
  data() {
    return {
      collapsed: true,
      fadeout: false,
      tl: null
    };
  },
  mounted() {
    this.initIntro();
  },
  methods: {
    fade() {
      this.fadeout = true;
      this.collapsed = true;
    },
    initIntro() {
      this.tl = gsap.timeline({ paused: true });
      this.tl.from(".dropdown-content .menu-link", {
        duration: 0.3,
        stagger: 0.05,
        y: -150,
        alpha: 0,
        ease: "easeInOut"
      });
    }
  },
  computed: {
    navHeight() {
      return this.$slots.default.length * 48 + 48;
    }
  },
  watch: {
    collapsed(nv) {
      if (nv !== true) {
        this.tl.delay(0.5).play();
      } else {
        //   console.log('open');
        this.tl.reverse();
      }
    }
  }
};
</script>
<style lang="scss">
.navbar {
  display: flex;
  justify-content: space-between;
  position: absolute;
  top: 0;
  left: 0;
  height: 72px;
  width: 100%;
  z-index: 99;

  & > div {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .hamburger,
  .logo {
    z-index: 10;
  }

  .logo {
    a {
      color: white;

      font-weight: 800;
      font-size: 22px;
      letter-spacing: 2px;
      margin-left: 20px;
      transition: color 0.6s ease-in-out;
      @include breakpoint(md){
          color: #620084;
      }

      &:hover {
        color: hotpink;
      }
    }
  }
}
.dropdown-menu {
  display: block;
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  height: auto;
  overflow: hidden;
  max-height: 400px;
  background-color: rgba(13, 0, 34, 0.97);
}

.dropdown-content {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  .menu-link {
    display: block;
    text-align: center;
    padding: 1.5rem 1rem;
    font-size: 1.15rem;
    color: white;
    text-decoration: none;
    filter: brightness(0.8);
    transition: filter 0.25s ease-in-out;

    &:hover {
      filter: brightness(1);
    }
  }
}
//slide on hamburger click
.slide-enter-active {
  transition: max-height 0.5s ease-out;
}
.slide-leave-active {
  transition: max-height 0.2s ease-out;
}
.slide-enter,
.slide-leave-to {
  max-height: 0;
}

//fade on menu click
.fade-enter-active {
  transition: opacity 0.3s ease, max-height 0.5s ease-out;
}
.fade-leave-active {
  transition: opacity 0.5s cubic-bezier(1, 0.5, 0.8, 1),
    max-height 0.5s ease-in 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  max-height: 0;
}
</style>
